import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

let UiCContainerBrandComponent = class UiCContainerBrandComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], UiCContainerBrandComponent.prototype, "backgroundImage", void 0);
__decorate([
    Input()
], UiCContainerBrandComponent.prototype, "brandImage", void 0);
__decorate([
    Input()
], UiCContainerBrandComponent.prototype, "text", void 0);
UiCContainerBrandComponent = __decorate([
    Component({
        selector: 'ui-c-container-brand',
        template: "<div class=\"container-inner w100 h100\" [style.background-image]=\"'url('+backgroundImage+')'\">\n  <div class=\"inner-content w100\">\n    <div class=\"container brand\">\n      <ion-text class=\"ion-text\">\n        <p style=\"font-weight: bold\">{{text}}</p>\n      </ion-text>\n      <ion-img class=\"ion-img mx-auto\" [src]=\"brandImage\"></ion-img>\n    </div>\n\n    <ng-content></ng-content>\n\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCContainerBrandComponent);

let UiCContainerBrandModule = class UiCContainerBrandModule {
};
UiCContainerBrandModule = __decorate([
    NgModule({
        declarations: [UiCContainerBrandComponent],
        imports: [
            IonicModule
        ],
        exports: [UiCContainerBrandComponent]
    })
], UiCContainerBrandModule);

/*
 * Public API Surface of ui-c-container-brand
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCContainerBrandComponent, UiCContainerBrandModule };
//# sourceMappingURL=wlp-ui-c-container-brand.js.map
